import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { SharedService } from '../common/shared.service';
import { Utils } from '../common/utils.component';
import { takeUntil } from "rxjs/operators";
declare var $: any;

import { Constants } from '../common/constants';
import { TooltipPosition } from '@angular/material/tooltip';
import { FormControl } from '@angular/forms';


@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html'
})
export class NavMenuComponent implements OnDestroy {

  navLinks: any[];
  activeLinkIndex = -1;
  isLoggedIn: boolean;
  isSettings: boolean = false;
  subscription: Subscription;
  activeItemFilter: string;
  activeItemSort: string;
  insideFolderfiles: boolean;
  isUpload: any;
  file: any;
  isUploadScreen: boolean;
  menuHeader: any = [];
  uploadDescText = Constants.UPLOAD_DESC_TEXT
  disabled: boolean = false;
  private onDestroy$: Subject<void> = new Subject<void>();
  isShare: boolean;
  isLoading:boolean;

  constructor(private utils: Utils, private router: Router, private sharedService: SharedService) {
    this.navLinks = [
      {
        label: 'Browse',
        link: './sites',
        index: 0
      },
      {
        label: 'Recent',
        link: './recent',
        index: 1
      }, {
        label: 'Favourites',
        link: './favourite',
        index: 2
      }, 
    ];
    this.searchText = '';
    this.subscription = sharedService.isLoggedIn
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        login => {
          this.isLoggedIn = login;
        });
    this.subscription = sharedService.isSettingsScreen
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        settings => {
          this.isSettings = settings;
        });
    this.subscription = sharedService.searchedText$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        searchText => {
          this.searchText = searchText;
        });

    this.subscription = sharedService.breadcrumMenuSource$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        obj => {
          if (this.menuHeader.length == 0) {
            this.menuHeader.push({ label: obj[1] == "Browse" ? "Sites" : obj[1], icon: 'keyboard_arrow_right', title: obj[0] });
          } else {
            this.menuHeader.push({ label: obj[0], icon: 'keyboard_arrow_right', title: obj[0] });
            if (this.menuHeader.length == 2)
              this.menuHeader[0] = { label: this.menuHeader[0]["title"], icon: 'keyboard_arrow_right', title: this.menuHeader[0]["label"] }
          }
       // utils.setBreadCrump()
        });
    this.subscription = sharedService.updateBreadcrumIndexSource$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        index => {
          this.menuHeader.splice(index + 1, this.menuHeader.length - 1);
        });

    this.subscription = sharedService.isShare$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        isShare => {
          this.isShare = isShare
        });

    this.subscription = sharedService.clearBreadcrumSource$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        clear => {
          if (clear)
            this.menuHeader.length = 0;
          else if (this.menuHeader.length == 1)
            this.menuHeader[0] = { label: this.menuHeader[0]["title"], icon: 'keyboard_arrow_right', title: this.menuHeader[0]["label"] }
        });
    this.subscription = sharedService.insideFolderfiles$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        insideFolderfiles => {
          this.insideFolderfiles = insideFolderfiles;
        });

    this.subscription = sharedService.activeFilter$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        filter => {
          this.activeItemFilter = filter
        });

    this.subscription = sharedService.activeSort$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        activeSort => {
          this.activeItemSort = activeSort;
        });

    this.subscription = sharedService.isUploadFlow$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        isUpload => {
          this.isUpload = isUpload;
        });

    this.subscription = sharedService.uploadFile$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        uploadFile => {
          this.file = uploadFile;
        });


    this.subscription = sharedService.isUploadScreen$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        isUploadScreen => {
          this.isUploadScreen = isUploadScreen;
        });

    this.subscription = sharedService.tabType$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        tabType => {
          if (tabType != -1) {
            this.activeLinkIndex = Number(tabType)
          }
        });

        this.subscription = sharedService.loading$
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          loading => {
            this.isLoading = loading
          });    
  }

  positionOptions: TooltipPosition[] = ['after', 'before', 'above', 'below', 'left', 'right'];
  position = new FormControl(this.positionOptions[4]);
  searchText;

  formatBytes(bytes, decimals = 2) {
    return this.utils.formatBytes(bytes, decimals)
  }

  ngOnInit(): void {
    this.setActiveItemFilter("All")
    this.setActiveItemSort("nameaz")
    this.router.events
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((res) => {
        if (!this.router.url.includes("/folder") && !this.router.url.includes("/login")) {
          this.activeLinkIndex = this.navLinks.indexOf(this.navLinks.find(tab => tab.link === '.' + this.router.url));
        }
      });

  }

  public getFileIcon() {
    var ext = this.file.name.split('.').pop();
    return this.utils.getFileIcon(ext);
  }

  clearSearchField() {
    this.searchText = '';
    this.sharedService.setSeachText(this.searchText);
  }

  onChange(newValue) {
    this.sharedService.setSeachText(newValue);
  }
  setActiveItemFilter(activeItem: string) {
    this.activeItemFilter = activeItem;
    this.sharedService.setFilter(activeItem);
  }

  setActiveItemSort(activeItem: string) {
    this.activeItemSort = activeItem;
    this.sharedService.setSort(activeItem);
  }

  breadCrumb(menu, index) {
    var menuHeader = this.menuHeader;
    var obj = [menu, index, menuHeader]
    this.sharedService.updateBreadcrumMenu(obj)
  }

  menuClick(i) {
    this.activeLinkIndex = i;
    this.menuHeader.length = 0;
  }

  menuOpened() {
    this.disabled = true;
  }

  menuClosed() {
    this.disabled = false;
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscription.remove(this.subscription);
    this.onDestroy$.next();
  }
}
